var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2919.4,
    height: 2855.4,
    viewBox: "0 0 2919.4 2855.4",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 2855.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m176.44 995.4c241.35-186.41 397.33-354.19 655.51-743.04 561.23 1202.4 1329.7 1511.1 1232.3 1564.3-197.17 112.29-1156.4-828.9-1272.4-953.07-139.48 62.688-615.39 281.81-615.39 131.83z",
    fill: "#62b01e",
    fillRule: "evenodd",
    stroke: "#62b01e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 107.83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/icon_correct.35c125a01875dcc6515971213cf9a1f0.svg";
export { ForwardRef as ReactComponent };